import React from "react";
import { Loading as LoadingBase } from "components";
import { getLogoSrc } from "../ColisActivLogo";

const Loading = () => {
  return <LoadingBase img={getLogoSrc()} />;
};

export default Loading;
